import { map } from "lodash";
import Reflux from "reflux";
import GrComponentFactory from "./gr_component_factory";
import UserShelvesStore from "../react_stores/user_shelves_store";


export default GrComponentFactory.createClass({
  displayName: "UserShelvesBookCounts",
  mixins: [Reflux.connect(UserShelvesStore, "userShelvesStore")],

  renderShelfCounts(shelves) {
    return map(shelves, (shelf) => (
        <a className="u-displayBlock"
           href={shelf.url}
           key={shelf.name}
           aria-label={`${shelf.displayName} shelf. ${shelf.bookCount} books.`}>
          {shelf.bookCount}
        </a>
    ));
  },

  renderShelfNames(shelves) {
    return map(shelves, (shelf) => (
        <a className="userShelvesBookCounts__nameLink"
           href={shelf.url}
           key={shelf.name}
           aria-label={`${shelf.displayName} shelf. ${shelf.bookCount} books.`}>
          {shelf.displayName}
        </a>
    ));
  },

  render() {
    const state = this.state.userShelvesStore;
    const shelves = state.defaultShelves.concat(state.customExclusiveShelves,
                                              state.nonExclusiveShelves);
    return (
      <div className="userShelvesBookCounts">
        <div className="userShelvesBookCounts__counts">
          {this.renderShelfCounts(shelves)}
        </div>
        <div>
          {this.renderShelfNames(shelves)}
        </div>
        <div className="userShelvesBookCounts__buffer" />
      </div>
    );
  },
});
